import React from "react";
import { formatSystemMessage } from "../../utils/format-system-message";
import { injectIntl } from "react-intl";

export default injectIntl(({ entry, intl }) => {
  // Use formatSystemMessage with intl
  const message = formatSystemMessage(entry, intl);
  // notificationsCenter.info(message);
  return message;
});
